import React,{ FC } from "react";
import { useSelector, useDispatch } from "react-redux";
import SideMenu from "../../../components/Menu/SideMenu";
import { RootState } from "../../../store";
import { openSliderAction } from "../../../store/application/action";
// import "./sidebar.scss";
import AuthMenu from "../../../components/Menu/AuthMenu";

interface SidebarProps {}

const Sidebar: FC<SidebarProps> = () => {
  const { openSlider } = useSelector((state: RootState) => ({
    openSlider: state.applicationReducer.openSlider,
  }));

  const dispatch = useDispatch();

  const closeSlider = () => {
    dispatch(openSliderAction({ open: false, type: "account" }));
  };

  return (
    <>
      <div
        id="mySidenav"
        className={`sidenav ${openSlider.open ? "opened" : "closed"}`}
      >
        <div className={`sidenavshow ${openSlider.open ? "accountshow" : ""}`}>
          <a className="closebtn close_icon_grey" onClick={closeSlider}></a>
          <AuthMenu />
        </div>
      </div>
      <div
        id="backDrop"
        onClick={closeSlider}
        className={`backdrop ${openSlider.open ? "opened" : "closed"}`}
      ></div>
    </>
  );
};

export default Sidebar;
